import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "@app/directives/shared.module";
import { c_dtable_automated_incident_detail_component } from "./c_dtable_automated_incident_detail_component";

@NgModule({
  imports: [CommonModule, FormsModule, SharedModule],
  declarations: [c_dtable_automated_incident_detail_component],
  exports: [c_dtable_automated_incident_detail_component],
})
export class c_dtable_automated_incident_detail_module {}
